import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PowerfulFeaturesSection.css';

function PowerfulFeaturesSection() {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/login');
  };

  return (
    <section className="powerful-features-section" id="features">
      <div className="features-bg-orb"></div>
      <div className="features-bg-mesh"></div>

      <div className="powerful-features-container">
        <div className="features-header-section">
          <div className="features-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
            Powerful Features
          </div>
          <h2 className="features-main-heading">The Future of Medical Learning is Here</h2>
          <p className="features-subheading">
            Experience the next generation of AI-powered medical education with cutting-edge features designed for modern healthcare professionals.
          </p>
        </div>

        <div className="features-cards-grid">
          {/* Card 1 */}
          <div className="feature-card-new" data-index="1">
            <div className="card-glow-effect"></div>
            <div className="feature-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="feature-card-title">AI-Powered Intelligence</h3>
            <p className="feature-card-desc">Advanced GPT-4 and Claude integration for instant, accurate medical answers backed by evidence-based research.</p>
            <div className="feature-metric">
              <span className="metric-number">99.8%</span>
              <span className="metric-label">Accuracy</span>
            </div>
          </div>

          {/* Card 2 */}
          <div className="feature-card-new" data-index="2">
            <div className="card-glow-effect"></div>
            <div className="feature-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="feature-card-title">Smart Study Materials</h3>
            <p className="feature-card-desc">Generate comprehensive study guides, flashcards, and practice questions tailored to your learning needs.</p>
            <div className="feature-metric">
              <span className="metric-number">1000+</span>
              <span className="metric-label">Topics</span>
            </div>
          </div>

          {/* Card 3 */}
          <div className="feature-card-new" data-index="3">
            <div className="card-glow-effect"></div>
            <div className="feature-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="feature-card-title">Instant Answers</h3>
            <p className="feature-card-desc">Get comprehensive medical information in seconds with our lightning-fast AI processing and retrieval system.</p>
            <div className="feature-metric">
              <span className="metric-number">&lt;2s</span>
              <span className="metric-label">Response Time</span>
            </div>
          </div>

          {/* Card 4 */}
          <div className="feature-card-new" data-index="4">
            <div className="card-glow-effect"></div>
            <div className="feature-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="feature-card-title">Evidence-Based Learning</h3>
            <p className="feature-card-desc">Access the latest medical literature, research papers, and clinical guidelines from trusted sources worldwide.</p>
            <div className="feature-metric">
              <span className="metric-number">50M+</span>
              <span className="metric-label">Research Papers</span>
            </div>
          </div>

          {/* Card 5 */}
          <div className="feature-card-new" data-index="5">
            <div className="card-glow-effect"></div>
            <div className="feature-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="feature-card-title">Interactive Learning</h3>
            <p className="feature-card-desc">Engage with AI-powered case studies, quizzes, and interactive scenarios for hands-on medical education.</p>
            <div className="feature-metric">
              <span className="metric-number">24/7</span>
              <span className="metric-label">Available</span>
            </div>
          </div>

          {/* Card 6 */}
          <div className="feature-card-new" data-index="6">
            <div className="card-glow-effect"></div>
            <div className="feature-icon-box">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M8 12L11 15L16 10" stroke="currentColor" strokeWidth="1.5"/>
              </svg>
            </div>
            <h3 className="feature-card-title">Exam Preparation</h3>
            <p className="feature-card-desc">Master USMLE, NEET-PG, PLAB exams with AI-generated practice questions and comprehensive study plans.</p>
            <div className="feature-metric">
              <span className="metric-number">85%</span>
              <span className="metric-label">Success Rate</span>
            </div>
          </div>
        </div>

        <div className="features-cta-wrapper">
          <button className="features-cta-btn" onClick={handleCTAClick}>
            <span>Start Learning Free</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default PowerfulFeaturesSection;
